import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import api from "../services/api";
import { useLocation } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const initialCheckDone = useRef(false);
  const location = useLocation();

  const checkAuth = async () => {
    try {
      // Verificar primero si hay un token en localStorage
      const token = localStorage.getItem("token");
      if (!token) {
        setIsAuthenticated(false);
        setUser(null);
        setIsLoading(false);
        return;
      }
      
      // Configurar el token en los headers para las solicitudes
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      const response = await api.get("/profile");
      
      // Handle the updated profile API response format
      // The new format returns user data inside a 'user' property
      const userData = response.data.user || response.data;
      console.log("Received user data from profile API:", userData);
      
      // Set user state with the profile data
      setUser(userData);
      setIsAuthenticated(true);
    } catch (error) {
      console.error("Error al verificar autenticación:", error);
      // Si hay un error, limpiamos el token que podría ser inválido
      localStorage.removeItem("token");
      delete api.defaults.headers.common['Authorization'];
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Check auth for all routes
    if (!initialCheckDone.current) {
      checkAuth();
      initialCheckDone.current = true;
    }
  }, []);

  // Re-verificar autenticación cuando cambia la ruta
  useEffect(() => {
    // No re-verificar durante la carga inicial
    if (initialCheckDone.current) {
      checkAuth();
    }
  }, [location.pathname]);

  const login = async () => {
    await checkAuth(); // Verificar autenticación inmediatamente después de login
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    delete api.defaults.headers.common['Authorization'];
    // Limpiar configuración de columnas al cerrar sesión
    sessionStorage.removeItem('visibleColumns');
    sessionStorage.removeItem('offerToken');
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
